<template>
  <div
    tabindex="0"
    class="inline-flex lg:overflow-x-visible gap-2.5 pr-4 sm:pr-6 lg:pr-0 lg:grid lg:grid-cols-3 lg:gap-4"
  >
    <div
      v-for="(species, index) in speciesTreated"
      :key="index"
      class="shrink-0 flex flex-col p-4 space-y-2 size-[100px] border border-neutral-00 rounded-md shadow-lg first:ml-4 sm:first:ml-6 lg:first:ml-0 lg:p-5 lg:h-[88px] lg:w-auto lg:flex-row lg:items-center lg:space-y-0 lg:space-x-4"
    >
      <fa
        :icon="speciesTreatedIcon(species.name)"
        class="text-2xl fa-fw text-neutral-900"
      />
      <span class="text-neutral-600 truncate text-xs font-light lg:font-normal lg:text-base lg:text-neutral-700">
        {{ $t(`pets.species.${species.name}`) }}
      </span>
    </div>
  </div>
</template>

<script>
import PetIcons from '@/mixins/PetIcons';

export default {
  name: 'VetsterSpeciesTreated',

  mixins: [PetIcons],

  props: {
    speciesTreated: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
